/* src/app/modules/concept/concept/concept-import.component.css */
.cim-header-text {
  min-width: 0;
  padding-right: 36px;
}
.cim-hint {
  margin: -4px 0 10px;
  font-size: 13px;
  color: var(--cf-text-muted, #6b7280);
}
.cim-section {
  margin-top: 20px;
}
.cim-tile {
  flex-direction: row;
  gap: 10px;
  padding: 14px 16px;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  margin: 0;
}
.cim-tile mat-icon,
.cim-drop mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  opacity: 0.7;
}
.cim-drop {
  width: 100%;
  gap: 6px;
  padding: 26px 16px;
  margin: 0;
  box-sizing: border-box;
}
.cim-drop mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
}
.cim-drop--over {
  border-color: var(--cf-brand, #e3fd64);
  color: #4d7a00;
  background: var(--cf-brand-light, #f9ffe0);
}
.cim-drop__title {
  font-size: 13px;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
}
.cim-drop__hint {
  font-size: 12px;
  font-weight: 400;
}
.cim-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #fecaca;
  border-radius: 8px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 13px;
}
.cim-alert mat-icon,
.cim-note mat-icon {
  flex-shrink: 0;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.cim-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 16px 0 0;
  font-size: 12px;
  color: var(--cf-text-muted, #6b7280);
}
.cim-preview {
  overflow: auto;
  max-height: 46vh;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.cim-done {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 24px 16px 12px;
  text-align: center;
}
.cim-done__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 6px;
  border-radius: 50%;
  background: #dcfce7;
  color: #16a34a;
}
.cim-done__icon mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.cim-done__title {
  font-size: 15px;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
}
.cim-done__file {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #374151;
}
.cim-done__hint {
  font-size: 12px;
  color: var(--cf-text-muted, #6b7280);
}
/*# sourceMappingURL=concept-import.component.css.map */
